import { reactive } from 'vue'

const theme = reactive({
  agentLogo: '',
  devLogo: 'logo.png',
  apiUrl: 'https://api.metaluxe.com.au/',
  bunnyApiUrl: 'https://api.bunny.net/',
  accessKey: '2a12fa1c-2bb2-47e8-b93bbf38df44-1987-49bc',

  videoLibraryId: '451245',
  streamCdnUrl: 'https://vz-2038b309-143.b-cdn.net',
  streamApiKey: '0444692b-4450-4343-95650f1eebf1-61d9-43b6',

  storageApiPassword: '2a12fa1c-2bb2-47e8-b93bbf38df44-1987-49bc',
  cdnUrl: 'https://retreat-pwa.b-cdn.net',
  devFolder: '/retreat-pwa',

  CinematicsIcon: '/img/ui-theme/videos-icon.svg',
  rendersIcon: '/img/ui-theme/renders-icon.svg',
  rangeIcon: '/img/ui-theme/range-icon.svg',
  panoramasIcon: '/img/ui-theme/panoramas-icon.svg',
  '360-ToursIcon': '/img/ui-theme/panoramas-icon.svg',

  dashboardMp4: '/theme/dashboard/background-video.mp4',

  // top level menu
  assetsMenuOrder: ['Cinematics', '360-Tours'],

  orderAssetsMenu: ['3 Bed', 'Amenities', 'Exterior'],

  retreatAsset: {
    panoramas: [0],
    panoramasName: ['Retreat'],
    panoramasUrl: ['https://storage.net-fs.com/hosting/7566552/51/'],
    balconyViews: [0],
    balconyViewsName: ['Retreat'],
    balconyViewsUrl: ['https://test-project.b-cdn.net/'],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
  },
  bedAsset: {
    balconyViews: [0],
    balconyViewsName: ['Retreat'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/51/'],
  },
  aminitiesAsset: {
    balconyViews: [0],
    balconyViewsName: ['Retreat'],
    balconyViewsUrl: ['https://storage.net-fs.com/hosting/7566552/56/'],
  },
})

export default { theme }
